import DiscountTypeAddForm from './DiscountTypeAddForm';

export default DiscountTypeAddForm;
